import { useFocusEffect } from "expo-router";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { View, Text } from "react-native";
import QRCode from "react-native-qrcode-svg";

import SecurityImage from "@/assets/security.svg";
import ButtonSmall from "@/components/button/ButtonSmall";
import Input from "@/components/input/Input";
import { storage } from "@/context/storage";
import { sendRequest } from "@/utils/ApiUtil";

type FormData = {
  validationCode: string;
};

export default function TwoFactorAuth() {
  const [isEnabled, setIsEnabled] = useState(false);
  const [url, setUrl] = useState("");
  const { t } = useTranslation();

  const { control, handleSubmit, reset } = useForm<FormData>({
    mode: "onSubmit",
  });

  useFocusEffect(
    React.useCallback(() => {
      const fetchOtpStatus = async () => {
        const isOtpEnabled = storage.getBoolean("user.auth.isOtpEnabled");
        if (isOtpEnabled) {
          setIsEnabled(true);
        } else {
          try {
            const response = await sendRequest("GET", "/otp", null, true);
            if (response) {
              setIsEnabled(false);
              setUrl(response.otpauthUrl);
            }
          } catch (error) {
            console.log(error);
          }
        }
      };
      reset();
      fetchOtpStatus();
    }, []),
  );

  const onSubmit = async (data: FormData) => {
    try {
      const response = await sendRequest(
        "POST",
        "/otp",
        {},
        true,
        false,
        data.validationCode,
      );
      if (response) {
        setIsEnabled(true);
        storage.set("user.auth.isOtpEnabled", true);
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <View className="bg-white1 w-full rounded-lg my-4 shadow">
      <View className="w-full p-2 bg-purple3 rounded-tl-lg rounded-tr-lg">
        <Text className="text-white1 text-xl font-light">
          {t("home/userpanel:sections.2fa.title")}
        </Text>
      </View>
      {!isEnabled && (
        <View className="w-full items-center p-3">
          <Text className="text-lg text-center">
            {t("home/userpanel:sections.2fa.notenable")}
          </Text>
          <View className="w-full items-center mt-4">
            {url && (
              <QRCode
                value={url}
                size={180}
                logoBackgroundColor="transparent"
              />
            )}
            <View className="flex-row items-center mt-2">
              <Input
                name="validationCode"
                label={t("home/userpanel:sections.2fa.validationcode")}
                placeholder={t("home/userpanel:sections.2fa.placeholder")}
                control={control}
              />
            </View>
            <ButtonSmall
              label={t("common:button.confirm")}
              onClick={handleSubmit(onSubmit)}
            />
          </View>
        </View>
      )}
      {isEnabled && (
        <View className="w-full items-center p-3">
          <Text className="text-lg font-light text-center">
            {t("home/userpanel:sections.2fa.enable")}
          </Text>
          <View className="w-full items-center mt-2">
            <SecurityImage width={120} height={120} />
            {/* <AntDesign name="Safety" size={48} color="green" /> */}
          </View>
        </View>
      )}
    </View>
  );
}
